import React from 'react';

import bgImage from './images/hs-with-hostastay-bg.png';

const BuildingStatusForm = () => {
  return (
    <div style={{ width: '100%' }}>
      <div style={{ maxWidth: '720px', height: '100%', margin: 'auto' }}>
        <div
          style={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: '240px',
            width: '98%',
            border: '1px solid #dadce0',
            borderRadius: '8px',
            marginTop: '12px',
            marginBottom: '24px'
          }}
        ></div>
        <iframe
          style={{ width: '100%', height: '2600px'}}
          title="form"
          src="https://docs.google.com/forms/d/e/1FAIpQLSeOvHOKVNiwsdUksOOIA_8guflBP26kcPNFP6FFTwlg26Bl3w/viewform?embedded=true"
          width="100%"
          height="2600px"
          frameborder="0"
          marginheight="0"
          marginwidth="0"
        >
          Loading…
        </iframe>
      </div>
    </div>
  );
};

export default BuildingStatusForm;
